export default __webpack_public_path__ + "static/media/icon-burn.f10e19c6.svg";